export default {"src":"/uk/_next/static/media/summaryIconGrey.0de206ea.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};